import { Box, Stack } from '@mui/material';
import React from 'react';
import { Advantages } from 'website/components/Advantages';
import { CompanyValues } from 'website/components/CompanyValues';
import { JobAdsSection } from 'website/components/JobAdsSection';
import { ContentLayout } from 'website/components/Layout/components/ContentLayout';
import { Offerings } from 'website/components/Offerings';
import { RecentBlogPosts } from 'website/components/RecentBlogPosts';
import { Subscribe } from 'website/components/SubscribeSection';
import { TopSection } from 'website/components/PlusTopSection';

export const Plus = () => {

  return (
    <ContentLayout>
      <TopSection />
      {/* <JobAdsSection /> */}
      <Offerings />
      {/* <CompanyValues /> */}
      <Advantages />
      {/* <RecentBlogPosts />
      <Subscribe /> */}
      <Box />
    </ContentLayout>
  );
};
